import React, { Component } from 'react';
import { Modal, Input, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { TextArea } = Input;

class RemoveProjectGroup extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
    }

    show = (memberId) => {
        this.setState({
            params: {memberId},
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    confirm = () => {
        const { params } = this.state;
        const { reason } = params;
        if (!reason || !reason.trim()) {
            message.warning('请填写CRC出组原因');
            return;
        }
        const options = {
            url: API_URL.user.leaveTheGroupByPm,
            data: {
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    handleNumberChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    render() {
        const { params, visible, loading } = this.state;
        const { reason } = params;
        return (
            <Modal
                title="CRC移出项目组"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="preview-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="460px"
            >
                <div style={{ padding: 20 }}>
                    <div>请填写CRC出组原因：</div>
                    <div style={{ margin: '6px 0', color: '#ffa500' }}>CRC出组后，不能再查阅该项目该中心数据、填写该项目该中心下的工时等</div>
                    <TextArea
                        rows={4}
                        value={reason}
                        placeholder="请填写"
                        onChange={e => this.handleNumberChange(e, 'reason')}
                    />
                </div>
            </Modal>
        );
    }
}

export default RemoveProjectGroup;


// WEBPACK FOOTER //
// ./src/components/member/crcInfo/RemoveProjectGroup.js